import React from 'react';
import * as T from '../template.tsx';
import '../main.css';
import motif from "../assets/motif.png"

function About() {
  return (
    <>
        <T.NavBar/>
        <div className="w-screen flex h-[calc(100%-5rem)]">
            <div className=" w-full text-center p-10 bg-home bg-cover  brightness-[80%] flex flex-col place-content-center" >
                <div className='self-center w-1/2 h-1/3 place-content-center'>
                    About
                </div>
            </div>
            <div>
                <img className="bottom-[200px] left-0 absolute w-[200px] z-10" src={motif} alt="motif"/>
                <img className="bottom-[100px] left-[250px] absolute w-[150px] z-10" src={motif} alt="motif"/>
                <img className="bottom-[400px] right-[50px] absolute w-[130px] z-10" src={motif} alt="motif"/>
                <img className="bottom-[80px] right-[120px] absolute w-[200px] z-10" src={motif} alt="motif"/>
            </div>
        </div>
    </>
    
  );
}

export default About;
